/* eslint-disable import/prefer-default-export */
import { gql } from '@apollo/client';
import { modules } from '@config';

export const getGuestRewards = gql`
    query getGuestRewards (
        $page: Int!
    ){
        guestRewards(page: $page) {
            caption_color
            caption_text
            visible
        }
    }
`;

export const getRewardsOfProduct = gql`
    query getRewards(
            $productId: Int!
        ) {
        rewards {
            highlight {
                category(productId: $productId) {
                    caption_color
                    caption_text
                    visible
                }
            }
        }
    }
`;

export const getRewards = gql`
    query getRewards {
        rewards {
            highlight {
                cart {
                    caption_color
                    caption_text
                    visible
                }
            }
        }
    }
`;

export const getRewardStatistic = gql`
    query getRewardsStatistic{
        getRewardsStatistic {
            balance
            expired
            redeemed
            rewarded
        }
    }
`;

export const getRewardsInformation = gql`
    query getRewardsInformation(
            $pageSize: Int!
            $currentPage: Int!
        ) {
        rewards {
            balance
            highlight {
                cart{
                    caption_color
                    caption_text
                    visible
                }
            }
            history {
            items(pageSize: $pageSize, currentPage: $currentPage) {
                items {
                    amount
                    action
                    expiring_amount
                    expiration_date
                    comment
                    points_left
                    days_left
                }
                page_info {
                    page_size
                    current_page
                    total_pages
                }
            }
                total_count
            }
        }
    }
`;

export const useRewardPoints = gql`
    mutation (
        $cart_id: String!
        $points: Float!
    ) {
        useRewardPoints(input: { 
            cart_id: $cart_id,
            points: $points
        }) {
            cart {
                addtional_fees{
                    data {
                        id_fee
                        fee_name
                    }
                }
                amasty_rewards_used_points{
                    used_points
                }
                ${modules.aw_rewardpoints.enabled
        ? `applied_reward_points {
                    reward_points
                    reward_points_amount
                }` : ''
}
                email
                id
                total_quantity
            }
            response
        }
    }
`;

export const saveNotificationOptions = gql`
    mutation (
        $earn_option: Boolean
        $expire_option: Boolean
    ) {
        saveNotificationOptions(input: {
            earn_option: $earn_option,
            expire_option: $expire_option
        }) {
            response
        }
    }
`;

export const getCustomerNotificationOptions = gql`
    query getCustomerNotificationOptions {
        getCustomerNotificationOptions {
            amrewards_earning_notification
            amrewards_expire_notification
        }
    }
`;
